import React from 'react';
import lang from '../lang';
import {RegistrationEvent} from '../machines/accountRegistration';
import {AlreadySocialRegisteredHint, SocialPlatform} from '../data/types';
import {AlreadyRegisteredScreenProps} from './AlreadyRegistered';
import {UseMachineType} from '../machines/useAccountRegistrationMachineType';

type Props = {
  registrationMachine: UseMachineType;
};

type ScreenProps = AlreadyRegisteredScreenProps & {
  providers: SocialPlatform[];
};

export type SocialAlreadyRegisteredScreenType =
  React.ComponentType<ScreenProps>;

export const SocialAlreadyRegistered = (
  props: Props & {children: SocialAlreadyRegisteredScreenType}
) => {
  const [
    {
      context: {
        navigator: {location},
      },
    },
    send,
  ] = props.registrationMachine;

  const message: string =
    (location.state?.message as string) ??
    lang.socialAlreadyRegistered.defaultMessage;

  const {email, links, providers} =
    (location.state?.hint as AlreadySocialRegisteredHint) ?? {};

  const onPrimaryActionClick = () => send(RegistrationEvent.GO_TO_LOGIN);
  const onUseDifferentEmailClick = () => send(RegistrationEvent.SKIP_TO_EMAIL);

  const renderProps: ScreenProps = {
    ...props,
    lang: lang.alreadyRegistered,
    onPrimaryActionClick,
    onUseDifferentEmailClick,
    message,
    email,
    links,
    providers,
  };

  const Screen = props.children;
  return <Screen {...renderProps} />;
};
